import BaseApi from '@/api/Base/BaseApi'
import {
  AddCommentPayload,
  CreateCommentPayload,
  GetAllDatasetsForReviewResponse,
  GetCommentListPayload,
  GetCommentListResponse,
  LabelingNodeInfo,
  LabelingNodeItem,
  LabelingObject
} from '@/api/LabelingNode/types'
import { UserInfo } from '@/api/User/types'

export default class LabelingNodeReviewApi extends BaseApi {
  getAvailableReviewers(projectId: string) {
    return this.agent.get<UserInfo[]>(`/project/${projectId}/available-reviewers`)
  }

  getAllDatasetsForReview(reviewNodeId: string) {
    return this.agent.get<GetAllDatasetsForReviewResponse>(`/review/${reviewNodeId}/datasets-all`)
  }

  // Review objects
  createComment(payload: CreateCommentPayload) {
    const { labelingItemId, comment, region, metadata } = payload

    return this.agent.post<LabelingObject>('/labeling/review-object', {
      labelingItemId,
      metadata,
      comment,
      region,
    })
  }

  appendComment(payload: AddCommentPayload) {
    const { labelingObjectId, comment } = payload
    return this.agent.post<LabelingObject>(`/labeling-object/${labelingObjectId}/comment`, { comment })
  }

  removeComment(labelingObjectId: string, commentId: string) {
    return this.agent.delete<LabelingObject>(`/labeling-object/${labelingObjectId}/comment/${commentId}`)
  }

  toggleResolveComment(labelingObjectId: string) {
    return this.agent.post<LabelingObject>(`/labeling-object/${labelingObjectId}/confirm-review-object`)
  }

  confirmReviewObjects(labelingNodeId: string, payload: { shouldCompleteReview: boolean, labelingItemId?: string }) {
    return this.agent.post<{ data: LabelingObject[] }>(`/labeling/${labelingNodeId}/confirm-review-objects`, payload)
  }

  getCommentList(payload: GetCommentListPayload) {
    const {
      labelingNodeId,
      itemsPerPage = 20,
      page,
      sortDir = 'asc',
      sortKey = 'createdAt',
      labelingItemId,
    } = payload
    return this.agent.get<GetCommentListResponse>(`/labeling/${labelingNodeId}/review-objects`, {
      params: {
        page,
        num_per_page: itemsPerPage,
        sort_key: sortKey,
        sort_dir: sortDir,
        labelingItemId,
      },
    })
  }

  /** @deprecated */
  toggleReviewForFileFinished(sourceId: string) {
    return this.agent.post<LabelingNodeItem>(`/labeling-item/${sourceId}/confirm`)
  }

  /** @deprecated */
  confirmAllLabelingItems(labelingNodeId: string) {
    return this.agent.post<LabelingNodeInfo>(`/labeling/${labelingNodeId}/confirm-all-items`)
  }

  /** @deprecated */
  finalizeReview(nodeId: string) {
    return this.agent.post(`/labeling/${nodeId}/finalize-review`)
  }

  /** @deprecated */
  rejectItems(nodeId: string) {
    return this.agent.post(`/labeling/${nodeId}/reject-items`)
  }
}
